export default {
  namespaced: true,
  state: {
    paymentDetail: {
      show: false,
      detail: {},
    },
    expertBankInfo: {
      show: false,
      type: "",
      id: null,
      groupInfo: {},
    },
  },
  getters: {
    getShow: (state) => state.paymentDetail.show,
    getBankInfoShow: (state) => state.expertBankInfo.show,
  },
  mutations: {
    TOGGLE_PAYMENT_DETAIL(state, obj) {
      if (obj.show) {
        state.paymentDetail.detail = obj.detail ? obj.detail : {};
      }
      state.paymentDetail.show = obj.show;
    },
    TOGGLE_BANK_INFO(state, obj) {
      if (obj.show) {
        state.expertBankInfo.type = obj.type ? obj.type : "";
        state.expertBankInfo.id = obj.id ? obj.id : null;
        state.expertBankInfo.groupInfo = obj.groupInfo ? obj.groupInfo : {};
      }
      state.expertBankInfo.show = obj.show;
    },
    TOGGLE_CHANGE_TYPE(state, obj) {
      state.expertBankInfo.type = obj.type ? obj.type : "";
    },
  },
  actions: {
    togglePaymentDetail({ commit }, obj) {
      commit("TOGGLE_PAYMENT_DETAIL", obj);
    },
    toggleBankInfo({ commit }, obj) {
      commit("TOGGLE_BANK_INFO", obj);
    },
    changeType({ commit }, obj) {
      commit("TOGGLE_CHANGE_TYPE", obj);
    },
  },
};
